import { TextInput } from "@ebsco-ui/ebsco-ui";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../../constants";
import sharedMessages from "../../../../../shared-messages";
import messages from "./update-user-form-fields-messages";

const PasswordField = ({ queryString }) => {
  const { formatMessage } = useIntl();

  const changePasswordPageUrl = `${ROUTES.PASSWORD_UPDATE}${queryString}`;

  return (
    <>
      <TextInput
        id="password"
        className="text-input password"
        name="password"
        label={formatMessage(sharedMessages.password)}
        disabled={true}
        defaultValue="••••••••••••••••"
        aria-hidden={true}
      />
      <Link className={"change-password-link"} to={changePasswordPageUrl}>
        <FormattedMessage {...messages.changePassword} />
      </Link>
    </>
  );
};

const mapStateToProps = state => ({
  queryString: state.router.location.search
});

PasswordField.propTypes = {
  queryString: PropTypes.string.isRequired
};

export { PasswordField };
export default connect(mapStateToProps)(PasswordField);
